export default __webpack_public_path__ + "static/media/clock.aa9d3adb.svg";